export enum AccessRule {
  Restricted = 'Restricted',
  Open = 'Open',
}
